import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormattedMessage, useIntl} from 'react-intl';

import {IStore} from 'redux/interface';
import {getTranslations} from 'redux/pageAsyncActions';
import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {BotType} from 'utils/hooks/use-chat-bot/interfaces';
import {Pages, TranslationKeys} from 'utils/constants/routeConstants';

import BotChat from 'components/bot-chat';

import {closeArticle} from 'redux/content/actions';

import DefaultIcon from 'assets/image/common/default.png';

import './styles.scss';
import {dialogueClearedAction} from '../../redux/dialogue/actions';

export const Xpedition: React.FunctionComponent = () => {
  const {
    loading
  } = useSelector((state: IStore) => state.status);
  const {
    settings
  } = useSelector((state: IStore) => state.auth);

  const dispatch = useDispatch();
  const intl = useIntl();

  useEffect(() => {
    dispatch(closeArticle());
    dispatch(dialogueClearedAction());
  }, []);

  const translationKey = useMemo(() => {
    const page = settings?.pages.find((p) => p.name === Pages.Xpedition);

    return page?.translationKey || TranslationKeys.Chat;
  }, [settings]);

  useGetTranslations({translationKey});

  return <div className="xpedition">
    {
      !loading.includes(getTranslations) && <>
        <h1 className="xpedition__title">
          <img src={DefaultIcon} alt="" className="xpedition__icon"/>
          <FormattedMessage
            id={'gritx.xpedition.title'}
            defaultMessage={'Xpedition'}
          />
        </h1>
        <BotChat mode={BotType.XpeditionList} title={intl.formatMessage({
          id: 'gritx.xpedition.title',
          defaultMessage: 'Xpedition'
        })}/>
      </>
    }
  </div>;
};
